export const animPropsNames = {
	initial: "initial",
	animate: "animate",
	exit: "exit",
};

export const noAnimPropsNames = {
	initial: "animate",
	animate: "animate",
};

export const scrollPropsNames = {
	initial: "initial",
	whileInView: "whileInView",
	exit: "exit",
};

export const noScrollPropsNames = {
	initial: "whileInView",
	whileInView: "whileInView",
};
